import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { IconSharedComponent } from './icon.component';
import { IconService, IconServiceConfig } from './icon.service';

@NgModule({
    declarations: [
        IconSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        IconSharedComponent
    ],
    providers: [
        IconService
    ]
})

export class IconSharedModule {

    static forRoot(config: IconServiceConfig): ModuleWithProviders {
        return {
            ngModule: IconSharedModule,
            providers: [
                {
                    provide: IconServiceConfig,
                    useValue: config
                }
            ]
        };
    }
}
